import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Level } from 'src/app/interfaces/academic-years';
import { ModuleService } from 'src/app/services/modules/module.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-monitoring',
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.scss']
})
export class MonitoringComponent implements OnInit {

  @ViewChild("formfollow", { read: ElementRef, static: true }) target1ref: ElementRef;

  level = "level1";
  elementSemected;
  items: any[];
  paginations = [{ number: 1, selected: true }, { number: 2, selected: false }, { number: 3, selected: false }, { number: 4, selected: false }];
  spinnerTable: boolean = true;
  error;
  public year: String;
  message;
  public subscription: Subscription;
  hide = true;
  showSpinner = false;
  item: Level;
  moduleByLevel:any;
  followUpForm: FormGroup;
  constructor(public config: NgbModalConfig, private modalService: NgbModal, public modules: ModuleService) {
    config.backdrop = 'static';
    config.keyboard = false;
    config.windowClass = "controleList";
    config.modalDialogClass = "controlModalFollow";
  }



  ngOnInit(): void {

    this.followUpForm = new FormGroup({
      date: new FormControl(
        '',
      ),
      step: new FormControl(
        '',
        [

        ]),

      notice: new FormControl(
        ''),
    });

    this.elementSemected = this.paginations[0];
    this.getCourses();
  }

  public init(error, message) {
    this.error = error;
    this.message = message;
  }

  /**
   * 
   * @param item 
   */
  public updateCourseInfo(item, content) {

    this.item = item;
    const today = new Date().toISOString().split('T')[0]; // Obtient la date du jour et la formate en 'YYYY-MM-DD'
    this.followUpForm.controls['date'].setValue(item.date ? item.date : today);
    this.followUpForm.controls['step'].setValue(item.step ? item.step : "");
    this.followUpForm.controls['notice'].setValue(item.notice ? item.notice : "");

    // this.followUpForm.get('step').patchValue('NouveauNomUtilisateur');

    this.init("", "");
    this.hide = false;
    Swal.fire({
      customClass: 'swal-wide',
      showCloseButton: true,
      showConfirmButton: false,
      focusConfirm: false,
      showCancelButton: false,
      html: this.target1ref.nativeElement,
      cancelButtonText: "Annuler"
    });
  }




  private getLevelName() {
    const firstTwoChars = this.item.id.slice(0, 2);
    let result;
    switch (firstTwoChars) {
      case "N1":
        result = "level1";
        break;
      case "N2":
        result = "level2";
        break;
      case "N3":
        result = "level3";
        break;
      case "N4":
        result = "level4";
        break;
      default:
        result = "level1";
    }
    return result;
  }

  public validate() {
    this.showSpinner = true;

    if (!this.followUpForm.value.notice && !this.followUpForm.value.date
      && !this.followUpForm.value.step) {
      this.init("Veuillez au moins renseigner un champ", "");
      this.showSpinner = false;
      return;
    }

    this.modules.update({ ...this.item, ...this.followUpForm.value }, this.year, this.getLevelName()).then(x => {
      this.init("", "Mise à jour éffectuée.");
      this.showSpinner = false;
    }, error => {
      this.init("Une erreur technique s'est produite. Veuillez contacter l'administrateur du site", "");
      this.showSpinner = false;
      console.log(error);
    })

  }

  public page(item) {
    this.elementSemected.selected = false;
    item.selected = true;
    this.elementSemected = item
    this.level = "level" + item.number;
    this.spinnerTable = true;
    this.getCourses();
  }

  /**
  * Retrieve all courses about the level class
  */
  private getCourses(): void {

    this.items = [];
    this.modules.getModule(this.level).subscribe((levels: Level[]) => {
      console.log(levels, this.level)
      this.items = levels;
      this.spinnerTable = false;
    }, error => {
      console.error(error);
      this.spinnerTable = false;
    })


  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();

  }

}
